import { Sidebar, MobileHead } from './components/Sidebar';
import { ChatView } from './components/Chat';
import { ApprovalsView, QuotesView, AuditView } from './components/Views';
import { SystemsView, SystemsScroll } from './components/Systems';
import { useStore } from './store';

function Page({ id, children }) {
  const { view } = useStore();
  return (
    <section className={'view' + (view === id ? ' active' : '')} id={'v-' + id}>
      {view === id && <div className="scroll"><div className="wrap">{children}</div></div>}
    </section>
  );
}

export default function App() {
  const { view } = useStore();
  return (
    <div className="shell">
      <Sidebar />
      <MobileHead />
      <main>
        <ChatView />
        <Page id="approvals"><ApprovalsView /></Page>
        <Page id="quotes"><QuotesView /></Page>
        <section className={'view' + (view === 'systems' ? ' active' : '')} id="v-systems">
          {view === 'systems' && <SystemsScroll><SystemsView /></SystemsScroll>}
        </section>
        <Page id="audit"><AuditView /></Page>
      </main>
    </div>
  );
}
